<template>
  <div :class="[tableClass, getClassName]">
    <div :class="getClassName + 'Header'">
      {{ $t(tableName) }}
      <span
        v-if="getShowTableMinimize"
        :class="getClassName + 'HeaderToggle'"
        @click="showSlot = !showSlot"
      >
        <img
          :src="getBaseUrl + `images/matrix/red_plus.svg`"
          v-show="!showSlot"
        />
        <img
          :src="getBaseUrl + `images/matrix/minus_line.svg`"
          v-show="showSlot"
        />
        <!-- <appAwesomeIcon
          v-show="!showSlot"
          icon="chevron_up"
          useClass="fa fa-chevron_up"
        />
        <appAwesomeIcon
          v-show="showSlot"
          icon="chevron_down"
          useClass="fa fa-chevron_down"
        /> -->
      </span>
    </div>
    <component :is="getTransitionUsedElement" name="slide-fade">
      <div v-show="showSlot">
        <slot></slot>
      </div>
    </component>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useUrlsStore } from "@/stores/modules/urls";
export default {
  props: ["tableName", "tableClass"],
  computed: {
    ...mapState(useUrlsStore, ["getBaseUrl"]),
    ...mapState(useWebproductStore, [
      "getShowTableMinimize",
      "getTransitionUsedElement"
    ])
  },
  data() {
    return { showSlot: true };
  }
};
</script>
